const types = {
  ALL_HORARIOS: "@horario/ALL",
  UPDATE_HORARIO: "@horario/UPDATE",
  FILTER_HORARIO: "@horario/FILTER",
  ADD_HORARIO: "@horario/ADD",
  RESET_HORARIO: "@horario/RESET",
  ALL_SERVICES: "@horario/ALL_SERVICES",
  REMOVE_HORARIO: "@horario/REMOVE",
};

export default types;
